angular.module('cpm').directive("timelineScrollTriggerControl", ($rootScope) => {
    return {
		restrict: "E",
		templateUrl: "builder/timeline-scroll-trigger-control.html",
		scope: {
			adunit: "=",
			canvas: "=",
			timeline: "="
        },
        link: ($scope) => {
            $scope.scrubOptions = [
                {id: 'false', name: 'None'},
                {id: 'true', name: 'With Scrollbar'},
                {id: 'with-delay', name: 'With Scrollbar + Delay'}
            ]

            $scope.toggleActions = [
                {id: 'play', name: 'Play'},
                {id: 'pause', name: 'Pause'},
                {id: 'resume', name: 'Resume'},
                {id: 'reset', name: 'Reset'},
                {id: 'restart', name: 'Restart'},
                {id: 'reverse', name: 'Reverse'},
                {id: 'none', name: 'None'}
            ]

            $scope.startEndOptions = [
                {id: 'top top', name: 'Top Top'},
                {id: 'top center', name: 'Top Center'},
                {id: 'top bottom', name: 'Top Bottom'},
                {id: 'center top', name: 'Center Top'},
                {id: 'center center', name: 'Center Center'},
                {id: 'center bottom', name: 'Custom Value'},
                {id: 'bottom top', name: 'Bottom Top'},
                {id: 'bottom center', name: 'Bottom Center'},
                {id: 'bottom bottom', name: 'Bottom Bottom'},
                {id: 'custom', name: 'Custom'}
            ]

            if(!!$scope.timeline && !$scope.timeline.scrollTrigger) {
                $scope.timeline.scrollTrigger = {
                    enabled: false,
                    scrubOptions: {
                        value: "true",
                    },
                    startOptions: {
                        value: 'top top'
                    },
                    endOptions: {
                        value: 'bottom bottom'
                    },
                    toggleActions: {
                        onEnter: 'play',
                        onLeave: 'pause',
                        onEnterBack: 'resume',
                        onLeaveBack: 'reset'
                    }
                }
            }

        }
    }
});